import request from '@/utils/request2'

// 列表(主数据列表)
export function loadStoreTagListDataApi(data) {
  return request({
    url: 'tms-web/storeTag/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportStoreTagListDataApi(data) {
  return request({
    url: 'tms-web/storeTag/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveStoreTagApi(data) {
  return request({
    url: 'tms-web/storeTag/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateStatusStoreTagApi(data) {
  return request({
    url: 'tms-web/storeTag/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deleteStoreTagApi(data) {
  return request({
    url: 'tms-web/storeTag/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewStoreTagApi(data) {
  return request({
    url: 'tms-web/storeTag/view',
    method: 'post',
    data
  })
}

// 列表
export function listStoreTagApi(data) {
  return request({
    url: 'tms-web/storeTag/list',
    method: 'post',
    data
  })
}
